import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/FooterSection.css';

const FooterSection = () => {
  const { t } = useTranslation();
  
  return (
    <section className="footer-section">
      <div className="footer-container">
        <div className="footer-logo-container">
          <img src="/logo/Frame.svg" alt="SKYRIS logo" className="footer-logo white-logo" />
        </div>
        <h1 className="footer-title">SKYRIS</h1>
        <p className="footer-subtitle">The world's first flying pet</p>
        
        <div className="footer-bottom">
          <div className="footer-contact">
            <a href="mailto:flyhigh@skyrisai.com" className="footer-email">flyhigh@skyrisai.com</a>
          </div>
          
          <div className="footer-schools">
            <img src="/images/page19/A.png" alt="School logo A" className="school-logo" />
            <img src="/images/page19/B.png" alt="School logo B" className="school-logo" />
            <img src="/images/page19/C.png" alt="School logo C" className="school-logo" />
            <img src="/images/page19/D.png" alt="School logo D" className="school-logo" />
            <img src="/images/page19/E.png" alt="School logo E" className="school-logo" />
            <img src="/images/page19/F.png" alt="School logo F" className="school-logo" />
            <img src="/images/page19/G 1.png" alt="School logo G" className="school-logo last-logo" />
          </div>
          
          <div className="footer-copyright">
            <p>All rights reserved @SKYRIS</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FooterSection; 